import { render, staticRenderFns } from "./HelpWidget.vue?vue&type=template&id=f3469936&scoped=true&"
import script from "./HelpWidget.vue?vue&type=script&lang=js&"
export * from "./HelpWidget.vue?vue&type=script&lang=js&"
import style0 from "./HelpWidget.vue?vue&type=style&index=0&id=f3469936&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3469936",
  null
  
)

export default component.exports